import { Component, OnInit, Input } from '@angular/core';
// import { FormControl } from '@angular/forms';

import { DepartamentService } from './../../services/departaments/departament.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.scss']
})
export class IndicatorsComponent implements OnInit {

  @Input() set departamentActiveInput(_departamentActive: any) {
    this.departamentActive = _departamentActive;
    console.log('this.departamentActive--------->', this.departamentActive);
    if (this.yearOne && this.yearTwo) {
      this.getIndicatorsDetails()
    }

  };
  @Input() years;

  departamentActive: any = false;

  indicators: any = [];
  itemsNav = [];
  selectItem;

  yearOne;
  yearTwo;

  constructor(
    private departamentService: DepartamentService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {

    this.yearOne = this.years[this.years.length - 1].year;
    this.yearTwo = this.years[0].year;

    if (this.yearOne && this.yearTwo) {
      this.getIndicatorsDetails();
    }


  }

  getIndicatorsDetails() {

    if (this.yearOne > this.yearTwo) {
      this.toastr.error('El segundo año debe ser mayor o igual al primero, para obtener los detalles de ' + this.departamentActive.name)
      return false;
    }

    let aux = this.indicators;
    this.departamentService
      .getIndicatorsDetails(this.departamentActive.code, [this.yearOne, this.yearTwo]).subscribe(indicators => {

        console.log('indicators---------->', indicators);

        this.indicators = (indicators != null) ? indicators : false;

        if (this.yearOne != this.yearTwo) {
          if (this.indicators) {

            this.itemsNav = this.indicators.criteriosList.map(item => {

              let data = {
                title: `${item.criterio}`,
                active: false,
                icon: '',
                color: ''
              };

              let icon = '';
              let color;

              switch (data.title) {
                case 'Ambiental':
                  icon = "<i class='flaticon-ecology'></i>"
                  color = '#F28321';
                  break;
                case 'Cultural':
                  icon = "<i class='flaticon-vase'></i>"
                  color = '#006738';
                  break;
                case 'Económico':
                  icon = "<i class='flaticon-money'></i>"
                  color = '#ED1651';
                  break;
                case 'Empresarial':
                  icon = "<i class='flaticon-branding'></i>"
                  color = '#B94E24';
                  break;
                case 'Estrategia de mercadeo':
                  color = '#682062';
                  icon = "<i class='flaticon-equal'></i>"
                  break;
                case 'Gestión de destino':
                  icon = "<i class='flaticon-shipped'></i>"
                  color = '#ECCD1A';
                  break;
                case 'Infraestructura':
                  icon = "<i class='flaticon-equal'></i>"
                  color = '#C1932B';
                  break;
                case 'Social':
                  icon = "<i class='flaticon-network'></i>"
                  color = '#AC2950';
                  break;
              }

              data.icon = icon;
              data.color = color;
              return data;
            })
            console.log('this.itemsNav----------->', this.itemsNav);
            this.selectItem = this.itemsNav[0];

          }
        } else {
          this.indicators = aux;
        }



      });
  }

  setSelectItem(item) {
    this.selectItem = item;
  }



}
